<template>
  <div class="flex flex-col justify-between text-center">
    <div class="w-full bg-beige-academy-300 text-white relative flex items-center
    tracking-widest uppercase py-6 text-xl mb-8 justify-end">
      <h1 class="absolute text-center w-full"> {{$t('editingSlots.yourLesson')}} </h1>
      <button @click.prevent="$modal.hide('open-slot-modal')" class="px-4 z-20">
        <close-icon />
      </button>
    </div>
    <div class="w-3/4 mx-auto flex flex-col justify-between text-lg mb-8 font-sans-serif
    text-center">
      <div class="mb-2">
        <strong>
          {{ selectedSlot && selectedSlot.start.format('DD/MM/YYYY') }}</strong>
      </div>
      <div class="mb-2">
        {{$t('bookingSlots.from')}}  <strong class="mr-4">
          {{ selectedSlot && selectedSlot.start.formatTime() }}</strong>
        {{$t('bookingSlots.to')}} <strong>
          {{ selectedSlot && selectedSlot.end.formatTime() }}</strong>
      </div>
      <div class="flex flex-row justify-between mt-6 text-sm">
        <modal-button @click="$emit('delete')"
        :buttonPlaceholder="$t('editingSlots.delete')"
        buttonClass="uppercase" />
        <modal-button @click="$emit('edit')"
          :buttonPlaceholder="$t('editingSlots.edit')"
          buttonClass="uppercase" />
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from '../graphics/CloseIcon.vue';
import ModalButton from '../graphics/ModalButton.vue';

export default {
  props: ['selectedSlot'],

  components: {
    ModalButton,
    CloseIcon,
  },

};
</script>
